import { Component, OnInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { OtherTemplatesService } from '../../home/services/other-templates.service';
import { DocsNames } from '../../dto/docs-names';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-view-docs',
  templateUrl: './view-docs.component.html',
  styleUrls: ['./view-docs.component.css'],

})
export class ViewDocsComponent implements OnInit {
  name: string;
  docName: string;
  content;

  constructor(
    private templatesService: OtherTemplatesService,
    private route: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private sanitizer: DomSanitizer
  ) { }



  ngOnInit() {
    this.name = this.route.snapshot.paramMap.get('name');

    if( this.name == 'cancellation_confirmation_de' || this.name == 'cancellation_confirmation_en' ) {
this.name = '__NOT_FOUND__';
}

      this.templatesService.getForView(this.name).subscribe(
        result => {
          this.docName = DocsNames[result.name];
          this.content = this.sanitizer.bypassSecurityTrustHtml(result.html);
        },
        err => {
          this.docName = 'No document available';
          this.content = `The document is not available at the moment, please contact your administrator or come back later.
                        We apologize for the inconvenience.`;
        }
        );
  }
}
